import { ExpedienteDetailPage as SharedExpedienteDetailPage } from "@tribunalea/ui";
import { plainTextToDocument } from "@tribunalea/document-editor";
import { useApi } from "../App.jsx";
import { WorkspaceDrafts } from "../components/WorkspaceDrafts.jsx";

export function ExpedienteDetailPage(props) {
  const api = useApi();
  return (
    <SharedExpedienteDetailPage
      api={api}
      renderDrafts={WorkspaceDrafts}
      toDocument={plainTextToDocument}
      {...props}
    />
  );
}
